import React from "react";
import Container from "@material-ui/core/Container";
import Card from "@material-ui/core/Card";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import { emphasize } from "@material-ui/core/styles/colorManipulator";
import Section from "./Section";
import SectionHeader from "./SectionHeader";
import AspectRatio from "./AspectRatio";

const useStyles = makeStyles((theme) => ({
  gridItem: {
    // Add border that contrasts lightly with background color.
    // We use boxShadow so that it's hidden around outer edge
    // due to container <Card> having overflow: hidden
    boxShadow: `1px 1px 0 0 ${emphasize(theme.palette.background.paper, 0.08)}`,
    textAlign: "center",
  },
  imageContainer: {
    margin: "0 auto",
    maxWidth: "200px",
    marginBottom: "30px",
    "& img": {
      width: "100%",
    },
  },
}));

function FeaturesSection(props) {
  const classes = useStyles();

  const items = [
    {
      title: "Improve Performance",
      body: "By improving posture, balance, breathing, strength, hand-eye coordination, reaction time, focus, memory, decision making and awareness among other things.",
      image:
        "https://drive.google.com/uc?export=view&id=1dP5N0K_usmuRZC9mfyJOQx4ZdAB17wPc",
    },
    {
      title: "Predict and Prevent Serious Injuries",
      body: "By identifying, quantifying and mitigating bad habits before they become problems.",
      image:
        "https://drive.google.com/uc?export=view&id=1HArE6ZTIQOA3iJc86WBO_e8qOieuYaUa",
    },
    {
      title: "Cut Recovery Time in Half",
      body: "By taking a multi-dimensional approach and receiving fully customized resources, exercises & strategies.",
      image:
        "https://drive.google.com/uc?export=view&id=1fXCqHtRNmbKC6Gzkuc8ZZRUlJHuqM_yW",
    },
    {
      title: "Track Progress",
      body: "Our gamified app helps you stay engaged and motivated while making the entire experience more enjoyable.",
      image:
        "https://drive.google.com/uc?export=view&id=1yzVOir2G8UTARwL_VSxRwbDeSuMWoD8f",
    },
  ];

  return (
    <Section
      bgColor={props.bgColor}
      size={props.size}
      bgImage={props.bgImage}
      bgImageOpacity={props.bgImageOpacity}
    >
      <Container>
        <SectionHeader
          title={props.title}
          subtitle={props.subtitle}
          size={4}
          textAlign="center"
        />
        <Card raised={false}>
          <Grid container={true}>
            {items.map((item, index) => (
              <Grid
                item={true}
                xs={12}
                md={6}
                className={classes.gridItem}
                key={index}
              >
                <Box p={6}>
                  <div className={classes.imageContainer}>
                    <AspectRatio ratio={4 / 3}>
                      <img src={item.image} alt={item.title} />
                    </AspectRatio>
                  </div>
                  <Typography variant="h5" gutterBottom={true}>
                    {item.title}
                  </Typography>
                  <Typography variant="subtitle1">{item.body}</Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Card>
      </Container>
    </Section>
  );
}

export default FeaturesSection;
